module.exports = __webpack_public_path__ + "static/media/jekyll.9a6784d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-alternatives/images/jekyll.png
// module id = 970
// module chunks = 0